import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
  };
  static targets = ["drawer"];

  open(event) {
    event.stopPropagation();
    this.drawerTarget.classList.remove("hidden");
  }

  close() {
    this.drawerTarget.classList.add("hidden");
  }

  stopPropagation(event) {
    // A click happened inside the drawer. Stop propagation to prevent the drawer from closing.
    event.stopPropagation();
  }
}
